<template>
  <div>
    <v-layout row class="ml-3 mt-3 mr-3">
      <div v-show="false"> {{getMaterialRegisterCounter}} </div>
      <span :class="ui.textSubheading">
        <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
          Parts Register
        </v-chip>
      </span>
      <v-spacer/>
      <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
        <v-avatar>
          <v-icon>playlist_add</v-icon>
        </v-avatar>
        {{registerSize}}
      </v-chip>
    </v-layout>
    <v-layout row class="ml-1">
      <ImportList :data="{tag: 'L1'}"/>
    </v-layout>
    <v-layout row class="mt-4 mr-2">
      <v-spacer/>
      <Import :data="{tag: 'L1'}"/>
    </v-layout>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import Import from "@/data/import/components/Import";
import ImportList from "@/data/import/components/ImportList";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true
    };
  },
  mixins: [apptheme],
  // eslint-disable-next-line
  components: {
    Import,
    ImportList
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getMaterialRegister",
      "getMaterialRegisterCounter",
      "getDetailBasic"
    ]),
    registerSize() {
      let lengthSize = null;
      if (this.getMaterialRegister === undefined) {
        lengthSize = 0;
      } else if (this.getMaterialRegister === null) {
        lengthSize = 0;
      } else {
        lengthSize = this.getMaterialRegister.length;
      }
      return lengthSize;
    },
    registerTitle() {
      let title = "Register";
      if (this.getDetailBasic !== undefined) {
        if (this.getDetailBasic.tag === "A1") {
          title = "Bill of Materials";
        } else {
          title = "Parts Register";
        }
      }
      return title;
    }
  }
};
</script>
